import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ConsultantAttachmentFilter = ({ value, onChange }) => {
  return (
    <FormControl
      size="small"
      sx={{
        minWidth: '200px',
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'white',
          height: '40px',
          fontSize: '14px',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb',
          }
        }
      }}
    >
      <InputLabel sx={{ fontSize: '14px' }}>Individual</InputLabel>
      <Select
        value={value}
        label="Individual"
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="attached">Attached to individual</MenuItem>
        <MenuItem value="unattached">Not attached to individual</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ConsultantAttachmentFilter;
